import { c as _c } from "react/compiler-runtime";
import { useProduct } from "@/queries/useProduct";
import { usePdpStore } from "@/stores/usePdpStore";
import ImageUploadDropzone from "./ImageUploadDropzone";
import ImageUploadPreview from "./ImageUploadPreview";
import OptionLabel from "./OptionLabel";
import { useProductBuilderContext } from "./ProductBuilderContext";
import { useProductMicrocopy } from "./useProductMicrocopy";
export default function ImageUpload() {
  const $ = _c(16);
  const {
    product
  } = useProductBuilderContext();
  const {
    data: productAdmin
  } = useProduct(product.sku);
  const microcopyFields = useProductMicrocopy();
  const uploadedFileInfo = usePdpStore(_temp);
  const setUploadedFileInfo = usePdpStore(_temp2);
  const setImageWidth = usePdpStore(_temp3);
  const setImageHeight = usePdpStore(_temp4);
  if (productAdmin && !productAdmin.allowImageUpload) {
    return null;
  }
  const imageUploadLabel = microcopyFields?.imageUploadLabel ?? "Upload Artwork";
  const imageUploadHelper = microcopyFields?.imageUploadHelper;
  const controlIdBase = `image-upload-${product.sku}`;
  const labelId = `${controlIdBase}-label`;
  const helpDialogId = `${controlIdBase}-help-dialog`;
  let t0;
  if ($[0] !== setImageHeight || $[1] !== setImageWidth || $[2] !== setUploadedFileInfo) {
    t0 = function handleDelete() {
      setUploadedFileInfo(undefined);
      setImageWidth(undefined);
      setImageHeight(undefined);
    };
    $[0] = setImageHeight;
    $[1] = setImageWidth;
    $[2] = setUploadedFileInfo;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleDelete = t0;
  let t1;
  if ($[4] !== helpDialogId || $[5] !== imageUploadHelper || $[6] !== imageUploadLabel || $[7] !== labelId) {
    t1 = <OptionLabel id={labelId} label={imageUploadLabel} optional={true} helper={imageUploadHelper} helpDialogId={helpDialogId} />;
    $[4] = helpDialogId;
    $[5] = imageUploadHelper;
    $[6] = imageUploadLabel;
    $[7] = labelId;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== handleDelete || $[10] !== labelId || $[11] !== uploadedFileInfo) {
    t2 = uploadedFileInfo ? <ImageUploadPreview onDelete={handleDelete} /> : <ImageUploadDropzone labelId={labelId} />;
    $[9] = handleDelete;
    $[10] = labelId;
    $[11] = uploadedFileInfo;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t1 || $[14] !== t2) {
    t3 = <div className="flex flex-col gap-1">{t1}{t2}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}
function _temp4(s_2) {
  return s_2.setImageHeight;
}
function _temp3(s_1) {
  return s_1.setImageWidth;
}
function _temp2(s_0) {
  return s_0.setUploadedFileInfo;
}
function _temp(s) {
  return s.uploadedFileInfo;
}